import React, { FC, useEffect } from 'react'

// third party components
import { useSelector } from 'react-redux'
import { useWallet } from '@solana/wallet-adapter-react'

// custom components
import MobileMenu from 'components/Menu/MobileMenu'
import MobileSearchBox from 'components/MobileSearchBox'
import PrimaryHeader from 'components/Header/PrimaryHeader'
import ConnectWalletModal from 'components/Modal/ConnectWalletModal'
import ProfileSetupModal from 'components/Modal/ProfileSetupModal'
import ShoppingCartMobileMenu from 'components/Menu/ShoppingCartMobileMenu'

// custom functions
import { useViewport } from 'utils'

// styles
import styles from './index.module.scss'
import { setColorTheme } from 'utils/helpers'

interface SecondaryLayoutProps {
  children?: any
  style?: React.CSSProperties
}

const SecondaryLayout: FC<SecondaryLayoutProps> = ({ children, style }) => {
  const viewport = useViewport()
  const openMobileMenu = useSelector<any>(state => state.openMobileMenu)
  const openMobileSearchBox = useSelector<any>(state => state.openMobileSearchBox)
  const openShoppingCart = useSelector<any>(state => state.openShoppingCart)
  const profileSetup = useSelector<any>(state => state.profileSetup)
  const { connected } = useWallet()

  const lightDarkMode = useSelector(state => (state as any).lightMode)

  useEffect(() => {
    setColorTheme(lightDarkMode)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={styles.container} style={style}>
      <>
        {/* {connected && (viewport === 'lg' || viewport === 'xl' || viewport === '2xl') && <Navbar />} */}
        <PrimaryHeader />
        <ConnectWalletModal />
        {/* <MobileMenu /> */}

        {openMobileMenu && (viewport === 'xs' || viewport === 'sm' || viewport === 'md') && <MobileMenu />}
        {openMobileSearchBox && (viewport === 'xs' || viewport === 'sm' || viewport === 'md') && <MobileSearchBox />}
        {openShoppingCart && (viewport === 'xs' || viewport === 'sm' || viewport === 'md') && (
          <ShoppingCartMobileMenu />
        )}
        <main className="w-full flex justify-center mt-[60px] lg:mt-[80px] min-h-[calc(100vh_-_60px)] lg:min-h-[calc(100vh_-_80px)]">
          {children}
        </main>
        {connected && profileSetup && <ProfileSetupModal />}
      </>
    </div>
  )
}

export default SecondaryLayout
